import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import blockIcon from "../../../../../assets/img/block-icon.svg";
import returnIcon from "../../../../../assets/img/modals/return.svg";
import { ChevronRight } from '../../../../../utils/svg';
import addFaqIcon from "../../../../../assets/img/products/add-faq-btn.svg";
import dotsIcon from "../../../../../assets/img/products/faq-dots.svg";
import removeicon from "../../../../../assets/img/products/removeicon.svg";
import CroppieModal from '../../../../croppie-modal';
import { hideLoader, showLoader } from '../../../../loader';
import ErrorMessage from '../../../../errors/errorMessage';

function Logo({data, showSectionChildModal, setShowSectionChildModal, error, setError, handleSubmit, handleUpdate }) {
    const close = () => setShowSectionChildModal(false);
    const [title, setTitle] = useState();
    // const [croppie, setCroppie] = useState(null);
    const [index, setIndex] = useState(null);
    // const [showCroppieModal, setshowCroppieModal] = useState(null);
    // const [croppie_image, setcroppie_image] = useState({ url: "", id: null });
    const [logo, setLogo] = useState([
        {
          image: "",
          image_url: "",
        },
      ]);
    //   const handleopenmodal = (e,i) => {
    //     setIndex(i);
    //     setcroppie_image({ url: "", id: null, name: null, type: null });
    //     generate_image_preview(e.target);
    //     hideLoader();
    // };
      
  function handleadd() {
    var newdata = [...logo];
    newdata.push({image: "" ,image_url: "", });
    setLogo(newdata);
  }

  function handleDelete(i) {
    const newarr = [...logo];
    newarr.splice(i, 1);
    setLogo(newarr);
  }

  // const handleHideModal = () => {
  //   setshowCroppieModal(false);
  //   setCroppie(null);
  //   setcroppie_image({ url: "", id: null });
  //   // history.push(basePath + "/products");
  // };
  // const croppieClose = () => {
  //   showLoader();
  //   setshowCroppieModal(false);
  //   setCroppie(null);
  //   setTimeout(() => {
  //     hideLoader();
  //   }, 400);
  // };
  // const croppedImage = () => {
  //   if (croppie !== null) {
  //     croppie
  //       .result({
  //         type: "canvas",
  //         size: "original",
  //         format: "png",
  //         quality: 1,
  //       })
  //       .then((response) => {
  //         const tempObj = { image_url: response };
  //         croppie
  //           .result({
  //             size: "viewport",
  //             format: "png",
  //             quality: 1,
  //             type: "blob",
  //           })
  //           .then((res) => {
  //             const tempLogo = [...logo];
  //             const currentObj = { ...tempLogo[index] };
  //             if (currentObj) {
  //               currentObj.image = response;
          
  //                 currentObj.image_url = response;
                  
  //                 tempLogo[index] = currentObj;
  //                 setLogo([...tempLogo]);
  //             }
  //             croppieClose()
  //           });
  //       });
  //   }
  // };
  function removeImage(index) {
    const tempLogo = [...logo];
      const currentObj = { ...tempLogo[index] };
      if (currentObj) {
        currentObj.image = null;
        currentObj.image_url = null;
        tempLogo[index] = currentObj;
        setLogo([...tempLogo]);
    }
  }
  // function generate_image_preview(input) {
  //   showLoader();
  //   if (input.files && input.files[0]) {
  //     let reader = new FileReader();
  //     if (input.files[0].size >= 5242880) {
  //       $("#image_file_input").val("");
  //       let notification_container = $(".notification-container");
  //       toast.error("File Size Should not exceed 5MBs");
  //       // showModal();
  //       return;
  //     }
  //     let val = input.files[0].name;
  //     let valid_extensions = ["png", "jpg", "jpeg"];
  //     let extension =
  //       val.substring(val.lastIndexOf(".") + 1, val.length) || val;
  //     if (!valid_extensions.includes(extension)) {
  //       $("#image_file_input").val("");
  //       let notification_container = $(".notification-container");
  //       toast.error("Invalid Image File. Should be png, jpg or jpeg");
  //       // showModal();
  //       return;
  //     }
  //     reader.onload = (event) => {
  //       setcroppie_image({
  //         ...croppie_image,
  //         url: event.target.result,
  //       });
  //       setshowCroppieModal(true);
  //       setTimeout(() => {
  //         const el = document.getElementById("image_demo2");
  //         try {
  //           console.log("el", el);
  //           if (el) {
  //             var croppieInstance = new Croppie(el, {
  //               enableExif: true,
  //               viewport: {
  //                 width: 850,
  //                 height: 300,
  //                 type: 'square',
  //                 showCroppieModal
  //               },
  //               boundary: {
  //                 width: 870,
  //                 height: 320
  //               },
  //             });
  //             croppieInstance
  //               .bind({
  //                 url: event.target.result,
  //               })
  //               .then(function () {
  //                 console.log("jQuery bind complete");
  //                 setTimeout(() => { }, 300);
  //               })
  //               .catch(() => {
  //                 croppieClose();
  //               });
  //             setCroppie(croppieInstance);
  //           }
  //         } catch { }
  //       }, 500);
  //     };
  //     reader.readAsDataURL(input.files[0]);
  //   }
  // }
  const handleValues = (a, i) => {
    const value = a.target.value;
    const name = a.target.name;
    const tempReview = [...reviews];
    const currentObj = { ...tempReview[i] };
    currentObj[name] = value;
    tempReview[i] = currentObj;
    setReviews([...tempReview]);
  };
  const handleSave = () => {
    const errors = [];
    const validLogo = logo.filter((data) => {
      if (!data?.image) {
          errors.push(`Image is required`);
          return false;
      }
      if (!title) {
        errors.push(`Title is required`);
        return false;
      }
      return data?.image
    });
    if (errors.length > 0) {
        setError(errors);
        return;
    }
    const formattedData = {
        title: title,
        logos: validLogo.map((logo) => ({
        image: logo?.image
      })),
    };

    handleSubmit(formattedData,'logo');
  };
  const handleUpdateData = (e) => {
    const errors = [];
    const validLogo = logo.filter((data) => {
        if (!data?.image) {
            errors.push(`Name is required`);
            return false;
        }
        return data?.image
      });
    if (errors.length > 0) {
        setError(errors);
        return;
    }
    const formattedData = {
        title: title,
        logos: validLogo.map((logo) => ({
        image: logo?.image
      })),
    };
    handleUpdate(formattedData,'logo',e.target.dataset?.value)
  }
  useEffect(() => {
    if (data?.meta) {
        const metaObject = JSON.parse(data.meta);
        const { title, logos } = metaObject;
        setTitle(title);
        setLogo(logos);
    }
  },[data?.meta])
  const addedVariable = (value,variable) => {
    if (variable == 'title') {
      setTitle(title ? `${title} ${value}` : value);
    }
  }
  const onfilechange = (e,i) => {
    setIndex(i);
    const fileList = e.target.files[0];
    var reader = new FileReader();

    reader.onload = function (event) {
      const tempLogo = [...logo];
      const currentObj = { ...tempLogo[i] };
      if (currentObj) {
        currentObj.image = event.target.result;
        currentObj.image_url = event.target.result;
  
          
          tempLogo[i] = currentObj;
          setLogo([...tempLogo]);
          // setIndex(null);
      }
    };
    reader.readAsDataURL(fileList);
}
    return (
        <Modal centered show={showSectionChildModal} onHide={close}>
            <div className="modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <form name="product_type" method="post" role="form">
                            <div className="notification-container"></div>
                            <div className="form-group">
                                <img src={blockIcon} width="40px" alt="" />
                                <h4 className="productHead1 mt-15px">Edit Logo's Section</h4>
                            </div>
                            <ErrorMessage error={error} />
                       
                            <div className="form-group mt-20px">
                                    <label className="productlabels">
                                       Title
                                    </label>   
                                    <div className='heading-input d-flex p-0 justify-content-between align-items-baseline zaapGlobal-input mt-10px'>
                                    <div className='heading-input-main d-flex w-100 '> 
                                    <input onChange={(a) => setTitle(a.target.value)} type="text" className="zaapGlobal-input text-dark " name="short_description" value={title} placeholder="Trusted by these and you soon! (Hopefully)"/>
                                    </div>
                                    <div style={{width:"52px"}} className="header-dropdown dropdown-toggle noselect " id="header-share-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="52" height="30" viewBox="0 0 52 30" fill="none">
                                        <rect width="52" height="30" rx="9" fill="#CDCBFF"/>
                                        <path d="M19.875 22V18.25M19.875 10.75V7M18 8.875H21.75M18 20.125H21.75M26.25 7.75L24.9494 11.1316C24.7379 11.6816 24.6321 11.9565 24.4676 12.1878C24.3219 12.3928 24.1428 12.5719 23.9378 12.7176C23.7065 12.8821 23.4316 12.9879 22.8816 13.1994L19.5 14.5L22.8816 15.8006C23.4316 16.0121 23.7065 16.1179 23.9378 16.2824C24.1428 16.4281 24.3219 16.6072 24.4676 16.8122C24.6321 17.0435 24.7379 17.3184 24.9494 17.8684L26.25 21.25L27.5506 17.8684C27.7621 17.3184 27.8679 17.0435 28.0324 16.8122C28.1781 16.6072 28.3572 16.4281 28.5622 16.2824C28.7935 16.1179 29.0684 16.0121 29.6184 15.8006L33 14.5L29.6184 13.1994C29.0684 12.9879 28.7935 12.8821 28.5622 12.7176C28.3572 12.5719 28.1781 12.3928 28.0324 12.1878C27.8679 11.9565 27.7621 11.6816 27.5506 11.1316L26.25 7.75Z" stroke="#012125" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      </div>
                                      <ul className="dropdown-menu share-dropdown" style={{borderRadius:"15px"}} aria-labelledby="header-share-dropdown">
                                          <li>
                                              <div onClick={()=>addedVariable('company_name','title')} className="share-dropdown-item share-dropdown-text d-flex justify-content-evenly align-items-center" >
                                                  Company Name
                                              </div>
                                          </li>
                                          <li>
                                            <div onClick={()=>addedVariable('lead_first_name','title')} className="share-dropdown-item share-dropdown-text d-flex justify-content-evenly align-items-center" >
                                                  Lead first Name
                                              </div>
                                          </li>
                                      </ul>
                                    </div>
                            </div>

                            {logo?.map((e, i) => {return (<div key={i}>
                                <div className="form-group mt-15px">
                                    <div className='qnaContainer' style={{padding:"10px"}}>
                                        <div className='w-85'>
                                            {!e?.image_url && !e?.image ?
                                            <button type="button" className="mt-0 newGraybtn position-relative bg-white">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333" />
                                                    </svg>Upload Logo
                                                    <input
                                                        type="file"
                                                        className="dropzone dropzone4 inset-0"
                                                        name="cover_image"
                                                        accept=".png,.jpg,.jpeg"
                                                        id="image_file_input"
                                                        onChange={(e)=>onfilechange(e,i)}
                                                    />
                                            </button>: null
                                              }
                                            <div className="preview-zone hidden "></div>

                                            <div>
                                                {
                                                e?.image_url || e?.image ? 
                                                <div className='d-flex align-items-center '>
                                                    <div>
                                                        <img className="prevImageU" src={e?.image_url ?? e?.image} />
                                                        {console.log(e?.image,"e?.image_url")}
                                                    </div>
                                                    <div>
                                                        <img onClick={(e) => removeImage(i)} src={removeicon} width={"22px"} style={{ padding: 4, cursor: "pointer" }} />
                                                    </div>
                                                </div>: null
                                                }
                                            </div>
                                        </div>
                                        {logo.length > 1 ? 
                                        <div>
                                            <img src={removeicon} width={"13px"} style={{margin:'0 10px'}} onClick={(a) => handleDelete(i)}/>
                                        </div>
                                         : <></>}
                                        </div>
                                    </div>
                                </div>
                            );})}


                            <div className="mt-15px">
                                <button type="button" className="newGraybtn" onClick={handleadd} width="100%">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333" />
                                    </svg>
                                    <span className="me-2">Add Logo</span>
                                </button>
                            </div>
                            <div class="text-center d-flex submit-buttons-fixed mt-20px">
                            <button type="button" onClick={close} class="close btn btn-grey btn-semi-rounded me-2 d-flex align-items-center justify-content-center save-btn-u">
                                <span class="me-2 font-weight-500">Cancel</span>
                                <small class="badge bg-light text-dark p-1">Esc</small>
                            </button>
                            <button data-value={data?.id} onClick={data?.id ? handleUpdateData : handleSave } type="button" class=" project-blue-btn ">
                                <span data-value={data?.id} class="me-2 font-weight-500">Save Changes</span>
                                <small data-value={data?.id} class=" project-blue-btn-badge ">
                                    <img src={returnIcon} alt="" />
                                </small>
                            </button>
                        </div>
                            
                        </form>
                    </div>
                </div>
            </div>
            {/* <CroppieModal show={showCroppieModal} handleHide={handleHideModal} croppieClose={croppieClose} croppedImage={croppedImage} modalWidth={500} productCroppie={"productCroppie"} /> */}

        </Modal>
    )
}

export default Logo